import * as actionTypes from "../actionTypes";

const initialState = {
  loading: false,
  serviceReport: null,
  labelServiceReport: null,
  contentReport: null,
  error: null,
  success: null,
  logError: null,
  logSuccess: null,
};

export const reportReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_SERVICE_REPORT_START:
      return {...state, loading: true, error: null, success: null, serviceReport: null};
    case actionTypes.GET_SERVICE_REPORT_SUCCESS:
      return {...state, loading: false, error: null, success: null, serviceReport: action.payload};
    case actionTypes.GET_SERVICE_REPORT_FAILURE:
      return {...state, loading: false, error: action.payload, success: null, serviceReport: null};

    case actionTypes.GET_LABEL_SERVICE_REPORT_START:
      return {...state, loading: true, error: null, success: null, labelServiceReport: null};
    case actionTypes.GET_LABEL_SERVICE_REPORT_SUCCESS:
      return {...state, loading: false, error: null, success: null, labelServiceReport: action.payload};
    case actionTypes.GET_LABEL_SERVICE_REPORT_FAILURE:
      return {...state, loading: false, error: action.payload, success: null, labelServiceReport: null};
    case actionTypes.SET_LOADING:
        return{...state, loading: false}
    case actionTypes.GET_CONTENT_REPORT_START:
      return {...state, loading: true, error: null, success: null, contentReport: null};
    case actionTypes.GET_CONTENT_REPORT_SUCCESS:
      return {...state, loading: false, error: null, success: null, contentReport: action.payload};
    case actionTypes.GET_CONTENT_REPORT_FAILURE:
      return {...state, loading: false, error: action.payload, success: null, contentReport: null};

    case actionTypes.GENERATE_REPORT_START:
      return {...state, loading: true, error: null, success: null};
    case actionTypes.GENERATE_REPORT_SUCCESS:
      return {...state, loading: false, error: null, success:action.payload.message};
    case actionTypes.GENERATE_REPORT_FAILURE:
      return {...state, loading: false, error: action.payload, success: null,};
    
      case actionTypes.CLEAR_REPORT_LOGS_START:
      return {...state, loading: true, logError: null, logSuccess: null};
    case actionTypes.CLEAR_REPORT_LOGS_SUCCESS:
      return {...state, loading: false, logError: null, logSuccess:action.payload.message};
    case actionTypes.CLEAR_REPORT_LOGS_FAILURE:
      return {...state, loading: false, logError: action.payload, logSuccess: null,};

    case actionTypes.SERVICE_REPORT_MESSAGE_HANDLER:
      return {
        ...state,
        error: action.payload,
        success: action.payload,
        logError: action.payload,
        logSuccess: action.payload,
        // loading:false
      };
    default:
      return {...state};
  }
};
